import moment from 'moment-timezone'

/**
 * Converts an ISO date string to a Date object (UTC-safe via moment-timezone).
 * Accepts both short format (YYYY-MM-DD) and full ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ).
 * Returns null if the string is empty or invalid.
 */
export function parseISOToDate(iso: string): Date | null {
  if (!iso) return null

  let m = moment.utc(iso, 'YYYY-MM-DD', true)

  if (!m.isValid()) {
    m = moment.utc(iso, moment.ISO_8601, true)
  }

  if (!m.isValid()) return null
  return m.toDate()
}
